import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";

const SessionExpiryModal = ({ open }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { localKey_selectedClient, localKey_userData } = LOCAL_STORAGE_TOKENS;

  const handleLoginAgain = () => {
    instance
      .loginRedirect(loginRequest)
      .then(() => {
        // No need to navigate here; handleRedirect in Login will take care of it
      })
      .catch((e) => {
        console.error("Error in login handle", e);
      });
  };

  const handleLogout = () => {
    localStorage.removeItem(localKey_selectedClient);
    localStorage.removeItem(localKey_userData);
    const logoutRequest = {
      account: instance.getAccountByHomeId(localStorage.getItem("userEmail")),
      postLogoutRedirectUri: `${process.env.REACT_APP_SERVER_URL}login`,
    };
    instance.logoutRedirect(logoutRequest);
    navigate("/login");
  };

  return (
    <Modal
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
      }}
      aria-labelledby="session-expiry-modal"
      aria-describedby="session-expiry-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(3px)",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
      }}
    >
      <Box
        sx={{
          width: "400px",
          bgcolor: "#1C1D24",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
          p: 4,
          outline: "none",
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          sx={{
            color: "#ffffff",
            fontSize: "24px",
            fontWeight: 500,
            textAlign: "center",
            mb: 2,
          }}
        >
          Session Expired
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: "#7E8799",
            textAlign: "center",
            fontSize: "16px",
            lineHeight: 1.5,
          }}
        >
          Due to inactivity since last 30 minutes, your session has expired.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            "& button": {
              flex: 1,
              maxWidth: "160px",
              height: "44px",
              fontSize: "15px",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: "8px",
            },
          }}
        >
          <Button
            variant="contained"
            onClick={handleLoginAgain}
            sx={{
              backgroundColor: "#01CCFF",
              color: "#000000",
              "&:hover": {
                backgroundColor: "#00b3e6",
              },
            }}
          >
            Re-login
          </Button>
          <Button
            variant="outlined"
            onClick={handleLogout}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              borderColor: "transparent",
              color: "#7E8799",
              "&:hover": {
                borderColor: "transparent",
                color: "#ffffff",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SessionExpiryModal;
